export class MessageConstants {
	public static NO_DATA = "No data found"
	public static SESSION_EXPIRE =
		"Your session has been expired. Please Login again."
	public static VALID_NUMBER = "Please enter valid number"
	public static SELECT_TRANSACTION_TYPE_ALSO =
		"Please select Transaction Type as well"
	// Single invoicing list (expensewise or travelerwise) failed to load
	public static readonly INVOICE_LIST_LOAD_FAILED =
		"Unable to load invoices. Please try again."
}
